import React from 'react';

import Helmet from './Helmet';

const ReferralTermsHelmet = () => {
  const title = 'Referral Terms | Canny';
  return <Helmet title={title} />;
};

export default ReferralTermsHelmet;
